import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { renewPath } from "../utils/renewTarget";
import "./SubscriptionPausedModal.css";

/**
 * Shown when the studio's own action (create event / upload) is refused with a
 * 402 because the subscription has expired. Its whole job is to make renewing
 * one click away — straight to the plans (where the balance can pay for it or
 * be topped up) — instead of a dead-end error message.
 *
 * `message` is the server's own explanation (grace vs locked, days remaining);
 * `locked` only changes the copy, not the action.
 */
function SubscriptionPausedModal({ open, message, locked = false, onClose }) {
  const navigate = useNavigate();
  // Renew the CURRENT plan. Resolved on open; until it lands, a click still
  // works via the same fallback renewPath uses.
  const [target, setTarget] = useState("/subscribe/pro_max_ultra");
  useEffect(() => {
    if (!open) return;
    let alive = true;
    renewPath().then((p) => { if (alive) setTarget(p); });
    return () => { alive = false; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="spm-overlay" onClick={onClose} role="presentation">
      <div className="spm-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="spm-title">
        <div className="spm-icon">{locked ? "🔒" : "⏳"}</div>
        <h2 id="spm-title" className="spm-title">
          {locked ? "Account locked" : "Uploads paused"}
        </h2>
        <p className="spm-message">
          {message || "Your subscription has expired. Renew your plan to continue."}
        </p>
        <p className="spm-help">Renew in a minute — your events and files are safe.</p>

        <button className="spm-btn-primary" onClick={() => navigate(target)}>
          Renew Plan
        </button>
        <button className="spm-btn-text" onClick={onClose}>Not now</button>
      </div>
    </div>
  );
}

export default SubscriptionPausedModal;
